import React from 'react';
import { Redirect } from 'react-router-dom'


export default function NotFound(props: any) {
  // const classes = useStyles();

  return <Redirect to='/' />
}